// Chart of accounts pulled from MirageFirm4 (Maister Plus).
// Bulgarian names translated to English; original Bulgarian retained for reference.
export interface AccountFixture {
  code: string
  name: string
  category: string
  level: number
}

export const accountsFixture: AccountFixture[] = [
  { code: '400', name: 'Suppliers', category: 'Liabilities', level: 1 },
  { code: '400-1', name: 'Suppliers - BGN', category: 'Liabilities', level: 2 },
  { code: '400-2', name: 'Suppliers - foreign currency', category: 'Liabilities', level: 2 },
  { code: '401', name: 'Suppliers - advances paid', category: 'Liabilities', level: 1 },
  { code: '401-1', name: 'Advances - BGN', category: 'Liabilities', level: 2 },
  { code: '401-2', name: 'Advances - foreign currency', category: 'Liabilities', level: 2 },
  { code: '410', name: 'Customers', category: 'Receivables', level: 1 },
  { code: '410-1', name: 'Customers - BGN', category: 'Receivables', level: 2 },
  { code: '410-2', name: 'Customers - foreign currency', category: 'Receivables', level: 2 },
  { code: '411', name: 'Customer advances', category: 'Receivables', level: 1 },
  { code: '420', name: 'Personnel', category: 'Liabilities', level: 1 },
  { code: '422', name: 'Accountable persons', category: 'Receivables', level: 1 },
  { code: '451', name: 'Corporate income tax', category: 'Tax', level: 1 },
  { code: '452', name: 'Personal income tax', category: 'Tax', level: 1 },
  { code: '453', name: 'VAT settlements', category: 'Tax', level: 1 },
  { code: '453-1', name: 'VAT charged on purchases', category: 'Tax', level: 2 },
  { code: '453-2', name: 'VAT charged on sales', category: 'Tax', level: 2 },
  { code: '453-8', name: 'VAT recoverable', category: 'Tax', level: 2 },
  { code: '453-9', name: 'VAT payable', category: 'Tax', level: 2 },
  { code: '455', name: 'Social security settlements', category: 'Tax', level: 1 },
  { code: '456', name: 'Customs settlements', category: 'Tax', level: 1 },
  { code: '498', name: 'Other debtors', category: 'Receivables', level: 1 },
  { code: '499', name: 'Other creditors', category: 'Liabilities', level: 1 },
  { code: '500', name: 'Cash - BGN', category: 'Cash', level: 1 },
  { code: '501', name: 'Cash - foreign currency', category: 'Cash', level: 1 },
  { code: '502', name: 'Bank account - BGN', category: 'Cash', level: 1 },
  { code: '503', name: 'Bank account - foreign currency', category: 'Cash', level: 1 },
  { code: '509', name: 'Other cash equivalents', category: 'Cash', level: 1 },
  { code: '509-1', name: 'Credit card', category: 'Cash', level: 2 },
  { code: '509-5', name: 'Revolut', category: 'Cash', level: 2 },
  { code: '600', name: 'Materials expenses', category: 'Expenses', level: 1 },
  { code: '601', name: 'External services expenses', category: 'Expenses', level: 1 },
  { code: '602', name: 'Depreciation expenses', category: 'Expenses', level: 1 },
  { code: '603', name: 'Salary expenses', category: 'Expenses', level: 1 },
  { code: '604', name: 'Social security expenses', category: 'Expenses', level: 1 },
  { code: '609', name: 'Other expenses', category: 'Expenses', level: 1 },
  { code: '611', name: 'Project expenses', category: 'Expenses', level: 1 },
  { code: '613', name: 'Long-term asset acquisition expenses', category: 'Expenses', level: 1 },
  { code: '617', name: 'Administrative expenses', category: 'Expenses', level: 1 },
  { code: '620', name: 'Interest expenses', category: 'Expenses', level: 1 },
  { code: '624', name: 'Foreign exchange expenses', category: 'Expenses', level: 1 },
  { code: '629', name: 'Other financial expenses', category: 'Expenses', level: 1 },
  { code: '650', name: 'Deferred expenses', category: 'Expenses', level: 1 },
  { code: '690', name: 'Extraordinary expenses', category: 'Expenses', level: 1 },
  { code: '701', name: 'Revenue from goods sales', category: 'Revenue', level: 1 },
  { code: '702', name: 'Revenue from services', category: 'Revenue', level: 1 },
  { code: '706', name: 'Revenue from financing', category: 'Revenue', level: 1 },
  { code: '709', name: 'Other operating revenue', category: 'Revenue', level: 1 },
]
